"use client";

import { useEffect } from "react";
import Link from "next/link";
import { Home, Search } from "lucide-react";
import { Button } from "@/app/components/shadcn/button";
import Header from "@/app/components/layout/header/Header";
import Footer from "@/app/components/layout/footer/Footer";
import MobileNav from "@/app/components/layout/mobileNav/MobileNav";
import SidebarActions from "@/app/components/common/sections/SidebarActions";
import useMobile from "@/app/lib/features/mobile/mobile.hook";
import useMobileNav from "@/app/hooks/useMobileNav";
import { trackGeneric } from "@/app/lib/tracking/interactions";

const NotFound = () => {
  const { isPurePage } = useMobile();
  const { isOpen, onClose } = useMobileNav();

  // 404 görüntülenme sayısı değerli bir metrik — InteractionPageViewTracker
  // 404 pathname'ini eşleştiremediği için burada elle gönderilir.
  useEffect(() => {
    trackGeneric("page_not_found", "view");
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      {!isPurePage && <Header />}
      {!isPurePage && <MobileNav isOpen={isOpen} onClose={onClose} />}
      <main className="grow">
        <div className="container-main min-h-[60vh] flex items-center justify-center py-12">
          <div className="flex flex-col items-center justify-center py-12 lg:py-16 px-4 text-center">
            <div className="mb-4 lg:mb-6">
              <Search className="w-16 h-16 lg:w-20 lg:h-20 text-gray-300" strokeWidth={1.5} />
            </div>

            <h2 className="text-xl lg:text-2xl font-semibold text-gray-900 mb-2">
              Sayfa Bulunamadı
            </h2>

            <p className="text-sm lg:text-base text-gray-500 text-center max-w-md mb-6 lg:mb-8">
              Aradığınız sayfa mevcut değil veya taşınmış olabilir.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
              <Button asChild>
                <Link href="/" onClick={() => trackGeneric("not_found_home", "click")}>
                  <Home className="w-4 h-4 mr-2" />
                  Anasayfa
                </Link>
              </Button>
            </div>
          </div>
        </div>
        {!isPurePage && <SidebarActions />}
      </main>
      {!isPurePage && <Footer />}
    </div>
  );
};

export default NotFound;